import request from '@/util/request'

// 用户登录
export function login(data) {
  return request({
    url: '/api/oauth/Login',
    method: 'POST',
    data,
    params: {
      client_id: 'admin',
      client_secret: '123456',
      scope: 'all',
      grant_type: 'password'
    }
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/oauth/Logout',
    method: 'get'
  })
}

// 用户信息
export function appCurrentUser() {
  return request({
    url: '/api/oauth/AppCurrentUser',
    method: 'get'
  })
}

// 更新用户语言
export function updateLanguage(data) {
  return request({
    url: `/api/system/Permission/Users/Current/SystemLanguage`,
    method: 'PUT',
    data
  })
}

// 查看账号密码（仅系统管理员/报名管理员）
export function getUserAccount(id) {
  return request({
    url: `/api/system/Permission/Users/${id}/Account`,
    method: 'GET'
  })
}
